/* eslint-disable prefer-object-spread */
import { checkCartStorege } from '../utils/Check';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const getStorege = (key: string): any => {
  const result: any = localStorage.getItem(key);
  if (result) {
    return JSON.parse(result);
  }
  return '';
};

export const saveStorege = (key: string, value: any): any => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeStorege = (key: string): any => {
  saveStorege(key, null);
};

export const updateRequestStorege = (
  key: string,
  value: any,
  type?: string,
  idRequestTotal?: any,
): any => {
  let result = getStorege(key);

  if (result) {
    if (type) {
      const checkDateTime = checkCartStorege(result.dateTimeRequest);

      if (checkDateTime) {
        removeStorege(key);
        return { remove: true };
      }
    }

    result.dateTimeRequest = `${new Date()}`;

    if (type === 'product') {
      result.pedido_cardapio.push(value);
      result.idPedidoCardapioTotal = idRequestTotal;
      result.promotionDeliveryFree = value.promotionDeliveryFree;
    }

    if (type === 'flavor') {
      if (result?.sabor) {
        result.sabor.push(value);
      } else {
        result = { ...result, sabor: [value] };
      }
    }

    if (type === 'additional') {
      if (result?.adicional) {
        result.adicional.push(value);
      } else {
        result = { ...result, adicional: [value] };
      }
    }

    if (type === 'optionLevel') {
      if (result?.opcoes) {
        result.opcoes.push(value);
      } else {
        result = { ...result, opcoes: [value] };
      }
    }

    localStorage.setItem(key, JSON.stringify(result));

    return true;
  }

  return false;
};
